import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface INewsInfoSetupFieldsPanel {}
export const NewsInfoSetupFieldsPanel: FC<
	INewsInfoSetupFieldsPanel
> = ({ }) => {
	return (
		<Box>
			<RHookFormDatePicker
				name="date"
				testId="date"
				label="Date"
				format="M dd, yy"
			/>
			<EnhancedTextAreaFieldRHF
				label="Description"
				id="description"
				testId={`description`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
